// extracted by mini-css-extract-plugin
export var redoItem = "_jr-1";
export var redoTrigger = "_jr-0";